document.querySelector('#main-content').classList.remove('paper');
